import {
  SET_TEMPLATES,
  SET_CUSTOM_TEMPLATES,
  APPLY_TIMELINE_TEMPLATE,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../index').BuiltInTemplate} BuiltInTemplate
 * @typedef {import('../index').CustomTemplate} CustomTemplate
 * @typedef {import('../index').PlotlineTemplate} PlotlineTemplate
 * @typedef {import('../index').PlotlineCustomTemplate} PlotlineCustomTemplate
 */

/**
 * @typedef {ReturnType<typeof setTemplates> | ReturnType<typeof setCustomTemplates> | ReturnType<typeof applyTimelineTemplate>} TemplatesActions
 */

/**
 * @param {Record<String, BuiltInTemplate>} templates
 * @return {{ type: 'SET_TEMPLATES', templates: Record<String, BuiltInTemplate> }}
 */
export const setTemplates = (templates) => ({
  type: SET_TEMPLATES,
  templates,
})

/**
 * @param {Array<CustomTemplate>} customTemplates
 * @return {{ type: 'SET_CUSTOM_TEMPLATES', customTemplates: Array<CustomTemplate> }}
 */
export const setCustomTemplates = (customTemplates) => ({
  type: SET_CUSTOM_TEMPLATES,
  customTemplates,
})

/**
 * @param {'series' | number} bookId
 * @param {PlotlineTemplate | PlotlineCustomTemplate} template
 * @param {number} selectedIndex
 * @return {{ type: 'APPLY_TIMELINE_TEMPLATE', bookId: 'series' | number, template: PlotlineTemplate | PlotlineCustomTemplate, selectedIndex: number }}
 */
export const applyTimelineTemplate = (bookId, template, selectedIndex) => ({
  type: APPLY_TIMELINE_TEMPLATE,
  bookId,
  template,
  selectedIndex,
})
